import { useCallback, useEffect, useMemo, useState } from "react";

const useBudgetRequestCanalDireto = () => {
  const [budgetMotivo, setBudgetMotivo] = useState(0);
  const [budgetMotivoError, setBudgetMotivoError] = useState(true);

  const [budgetObservacao, setBudgetObservacao] = useState("");
  const [budgetObservacaoError, setBudgetObservacaoError] = useState(true);

  const [budgetAgencia, setBudgetAgencia] = useState("");
  const [budgetAgenciaError, setBudgetAgenciaError] = useState(true);

  const [budgetMidia, setBudgetMidia] = useState(0);
  const [budgetMidiaError, setBudgetMidiaError] = useState(true);

  const [budgetExecutivo, setBudgetExecutivo] = useState("");
  const [budgetExecutivoError, setBudgetExecutivoError] = useState(true);

  const [budgetEstado, setBudgetEstado] = useState(0);
  const [budgetEstadoError, setBudgetEstadoError] = useState(true);

  const [budgetRequestValido, setBudgetRequestValido] = useState(false)

  useEffect(() => {
    if(!budgetMotivo)setBudgetMotivoError(true);
    if(!budgetAgencia)setBudgetAgenciaError(true);
    if(!budgetMidia)setBudgetMidiaError(true);
    if(!budgetExecutivo)setBudgetExecutivoError(true);
    if(!budgetEstado)setBudgetEstadoError(true);
    if(!budgetObservacao)setBudgetObservacaoError(false);

    if(budgetMotivoError || budgetEstadoError || budgetExecutivoError || budgetAgenciaError || budgetMidiaError) setBudgetRequestValido(false); 
    else setBudgetRequestValido(true);
  }, [
    budgetMotivo,
    budgetObservacao,
    budgetAgencia,
    budgetMidia,
    budgetExecutivo,
    budgetEstado,
  ]);

  const changeBudgetRequestFormCanalDireto = useCallback(async (name, value) => {
    switch (name) {
      case "budgetMotivo":
        return setBudgetMotivo(value);
      case "budgetObservacao":
        return setBudgetObservacao(value);
      case "budgetAgencia":
        return setBudgetAgencia(value);
      case "budgetMidia":
        return setBudgetMidia(value);
      case "budgetExecutivo":
        return setBudgetExecutivo(value);
      case "budgetEstado":
        return setBudgetEstado(value);
      case "budgetMotivoError":
        return setBudgetMotivoError(value);
      case "budgetObservacaoError":
        return setBudgetObservacaoError(value);
      case "budgetAgenciaError":
        return setBudgetAgenciaError(value);
      case "budgetMidiaError":
        return setBudgetMidiaError(value);
      case "budgetExecutivoError":
        return setBudgetExecutivoError(value);
      case "budgetEstadoError":
        return setBudgetEstadoError(value);
      default:
        return null;
    }
  }, []);

  return useMemo(
    () => ({
      budgetRequestCanalDireto: {
        budgetMotivo,
        budgetObservacao,
        budgetAgencia,
        budgetMidia,
        budgetExecutivo,
        budgetEstado,
        budgetMotivoError,
        budgetObservacaoError,
        budgetAgenciaError,
        budgetMidiaError,
        budgetExecutivoError,
        budgetEstadoError,
        budgetRequestValido,
      },
      changeBudgetRequestFormCanalDireto,
    }),
    [
      budgetMotivo,
      budgetObservacao,
      budgetAgencia,
      budgetMidia,
      budgetExecutivo,
      budgetEstado,
      budgetMotivoError,
      budgetObservacaoError,
      budgetAgenciaError,
      budgetMidiaError,
      budgetExecutivoError,
      budgetEstadoError,
      budgetRequestValido,
    ]
  );
};

export default useBudgetRequestCanalDireto;
